import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import "./index.css";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import ScheduleQueryItem from "../../components/ScheduleQueryItem";
import api from "api";
import { UserInfo, UserCompanyListingResponse } from "model/user";
import { ApiResponse, SelectOption } from "model/response";
import {
  ScheduleQuery,
  ScheduleQueryListingResponse,
} from "model/schedule_query";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import Select from "react-select";

const PAGE_LIMIT = 6;
interface ListingData {
  schuduleQueries: Array<ScheduleQuery>;
  page: number;
  total: number;
}

export default function ScheduleQueryListing() {
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
  const [listingData, setListingData] = useState<ListingData>({
    schuduleQueries: [],
    page: 0,
    total: 0,
  });
  const [name, setName] = useState<string>("");
  const [createdFrom, setCreatedFrom] = useState<string>("");
  const [createdTo, setCreatedTo] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<SelectOption | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // const debounceSearchName = useCallback(_.debounce(fetchData, 1000), []);

  useEffect(() => {
    initData();
  }, []);

  // useEffect(() => {
  //   debounceSearchName(name);
  // }, [name]);

  useEffect(() => {
    fetchData();
  }, [listingData?.page]);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    setLoading(false);
  };

  async function fetchData() {
    let url = `schedule_query?company_id=${companyId}&is_delete=0&limit=${PAGE_LIMIT}&page=${listingData?.page}`;
    if (name !== "") {
      url = url + `&name=${name}`;
    }
    if (createdFrom !== "") {
      url = url + `&created_on_from=${createdFrom}`;
    }
    if (createdTo !== "") {
      url = url + `&created_on_to=${createdTo}`;
    }
    if (selectedUser && selectedUser?.value) {
      url = url + `&user_id=${selectedUser?.value}`;
    }
    // setLoading(true)
    const res: ApiResponse = await ApiCaller.get(url);
    if (res?.status === "ok") {
      const data: ScheduleQueryListingResponse = res?.data;
      setListingData({
        ...listingData,
        ...{ schuduleQueries: data?.schedule_queries, total: data?.total },
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  if (loading) return <Loading />;

  return (
    <Container>
      <Row>
        <Col className="home-current-user-brand" xs={12}>
          <h3>
            {
              currentUser?.companies.find((comapny) => comapny.id == companyId)
                ?.name
            }
          </h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Button tag={Link} color="primary" to={"/create_schedule_query"}>
            Add new Schedule Query
          </Button>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Input
              style={styles.searchBox}
              placeholder="Search by query name, SQL..."
              onChange={(e) => {
                setName(e.target.value);
                setListingData({
                  ...listingData,
                  ...{ page: 0 },
                });
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <Label>Created From (mm/dd/yyy - UTC)</Label>
            <Input
              type="date"
              style={styles.filter}
              placeholder=""
              onChange={(e) => {
                setCreatedFrom(e.target.value);
                setListingData({
                  ...listingData,
                  ...{ page: 0 },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <Label>Created To (mm/dd/yyy - UTC)</Label>
            <Input
              type="date"
              style={styles.filter}
              placeholder=""
              onChange={(e) => {
                setCreatedTo(e.target.value);
                setListingData({
                  ...listingData,
                  ...{ page: 0 },
                });
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Button
            color="primary"
            onClick={() => {
              fetchData();
            }}
          >
            Search
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.floor(listingData?.total / PAGE_LIMIT) + 1}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            initialPage={0}
            onPageChange={async (page) => {
              setListingData({
                ...listingData,
                ...{ page: page.selected },
              });
            }}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </Col>
      </Row>
      <Row>
        {listingData?.schuduleQueries?.map((scheduleQuery) => {
          return (
            <Col xs={12} key={`${scheduleQuery?.id}`}>
              <ScheduleQueryItem
                scheduleQueryData={scheduleQuery}
                companyName={
                  currentUser?.companies.find(
                    (comapny) => comapny.id == companyId
                  )?.name
                }
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  // searchBox: {
  //   fontSize: 16,
  //   padding: 16,
  //   height: 48,
  // },
  // filter: {
  //   fontSize: 16,
  //   padding: 10,
  //   height: 38,
  // },
};
